export const RQ_EXAMPLELIST = 'exampleList'
export const RQ_EXAMPLE = 'example'
export const RQ_USERLIST = 'userList'
export const RQ_USER = 'user'
export const RQ_ROLELIST = 'roleList'
export const RQ_ROLE = 'role'
export const RQ_RESOURCELIST = 'resourceList'
export const RQ_PERMISSIONLIST = 'permissionList'


export const RQ_ASSETLIST = 'assetList'
export const RQ_ASSET = 'asset'


export const RQ_ASSETTRASHLIST = 'assetTrashList'
export const RQ_ASSETTRASH = 'assetTrash'



export const RQ_USERTRASHLIST = 'userTrashList'
export const RQ_USERTRASH = 'userTrash'

export const RQ_ROLEBYSUPERADMINLIST = 'roleBySuperAdminList'

